export const HOTJAR_HOTJAR_HJID = 4968509;
export const HOTJAR_HOTJAR_HJSV = 6;
